import { render, staticRenderFns } from "./EventsListCalendar.vue?vue&type=template&id=55413fa1&scoped=true"
import script from "./EventsListCalendar.vue?vue&type=script&lang=js"
export * from "./EventsListCalendar.vue?vue&type=script&lang=js"
import style0 from "./EventsListCalendar.vue?vue&type=style&index=0&id=55413fa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55413fa1",
  null
  
)

export default component.exports